import Immutable from 'immutable';
import cookies from 'js-cookie';
import jwtDecode from 'jwt-decode';
import { communicationStatus, cookieNames } from '~client/constants';
import { authActionTypes } from '~client/constants/actionTypes';
import { defaultCommunicationObject, updateCommunicationObject } from '~client/reducers/shared';
import { setItem, removeItem } from '~helpers/storage';
import { getCookieDomain, setLoginCookie } from '~helpers/login-utils';

const decodeToken = token => {
  const info = token ? jwtDecode(token) : {};

  if (typeof info.roles === 'object') {
    return {
      email: info.email || null,
      token,
    };
  }

  return {
    email: null,
    token: null,
  };
};

export const defaultState = Immutable.fromJS({
  base: decodeToken(cookies.get(cookieNames.token)),
  login: {
    communication: defaultCommunicationObject,
  },
  forgotPassword: {
    emailSent: false,
    communication: defaultCommunicationObject,
  },
  resetPassword: {
    communication: defaultCommunicationObject,
  },
  authList: {},
  getAuthList: {
    communication: defaultCommunicationObject,
  },
  auth: {},
  getAuthInfo: {
    communication: defaultCommunicationObject,
  },
});

const processLoggedIn = (state, action) => {
  setLoginCookie(action.setLoginCookie, action.token);
  return state.mergeDeep({
    base: decodeToken(action.token),
    login: {
      communication: updateCommunicationObject(communicationStatus.IDLE),
    },
    resetPassword: {
      communication: updateCommunicationObject(communicationStatus.IDLE),
    },
  });
};

const authReducer = (state = defaultState, action) => {
  switch (action.type) {
    case authActionTypes.INITIALIZE:
      return state.mergeDeep({
        [action.application]: defaultState?.toJS()[action.application],
      });

    case authActionTypes.FORGOT_PASSWORD_CS:
      return state.mergeDeep({
        forgotPassword: {
          communication: updateCommunicationObject(action.status, action.error),
        },
      });

    case authActionTypes.RESET_PASSWORD_CS:
      return state.mergeDeep({
        resetPassword: {
          communication: updateCommunicationObject(action.status, action.error),
        },
      });

    case authActionTypes.LOGIN_IN_CS:
      return state.mergeDeep({
        login: {
          communication: updateCommunicationObject(action.status, action.error),
        },
      });

    case authActionTypes.SET_USER_AUTH:
      return state.set('authList', action.payload.payload);

    case authActionTypes.GET_USER_AUTH_CS:
      return state.mergeDeep({
        getAuthList: {
          communication: updateCommunicationObject(action.status, action.error),
        },
      });

    case authActionTypes.SET_USER_ROLE:
      setItem('PMS_CURRENT_USER_AUTH', {
        authToken: cookies.get(cookieNames.token),
        payload: action.payload,
      });
      return state.set('auth', action.payload);

    case authActionTypes.LOGGED_IN:
      return processLoggedIn(state, action);

    case authActionTypes.LOGOUT:
      if (action.rememberMe) {
        cookies.remove(cookieNames.token, {
          path: '/',
          expires: 7,
          domain: getCookieDomain(),
        });
      } else {
        cookies.remove(cookieNames.token, {
          path: '/',
          domain: getCookieDomain(),
        });
      }
      removeItem('PMS_CURRENT_USER_AUTH');
      return state.mergeDeep({
        base: {
          token: null,
          email: null,
        },
        authList: {},
        auth: {},
      });

    case authActionTypes.EMAIL_RESET_SUCCESSFUL:
      return state.mergeDeep({
        forgotPassword: {
          emailSent: true,
          communication: updateCommunicationObject(communicationStatus.IDLE),
        },
      });

    default:
      return state;
  }
};

export default authReducer;
